import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 077E7728-7FDE-4846-9F55-9818EB397D58
 * name home-lightning-bolt
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lightning-bolt.svg
 * tags
 * - Home Automation 
 */
export const HomeLightningBoltIcon = createSvgIcon(<><path d="M12 3L2 12H5V20H19V12H22L12 3M11.5 18V14H9L12.5 7V11H15L11.5 18Z" /></>, 'HomeLightningBoltIcon');
export default HomeLightningBoltIcon